import { render, staticRenderFns } from "./StatusSummary.vue?vue&type=template&id=039565a0&scoped=true&"
import script from "./StatusSummary.vue?vue&type=script&lang=js&"
export * from "./StatusSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039565a0",
  null
  
)

export default component.exports